import React from 'react'
import {Link, useLocation} from "react-router-dom";
import {useEffect} from "react";
import { useHistory } from 'react-router-dom';
//uselocation hook  is used to active the home , about button which is pressed

const Navbar = () => {
  let history = useHistory();
  const handleLogout=()=>{
    localStorage.removeItem('token');
    history.push("/login")
  }
  let location = useLocation();
  useEffect(() => {
  }, [location]);
  return (
    <>
    {/* importing navbar from bootstrap */}
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">iNotebook</Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
          </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                {/* if Home is clicked it will be active */}
                  <Link className={`nav-link ${location.pathname === "/"?"active":""}`} aria-current="page" to="/">Home</Link>
                </li>
                <li className="nav-item">
                  <Link className={`nav-link ${location.pathname === "/about"?"active":""}`} to="/about">About</Link>
                </li>
              </ul>
  {/* if token is present i.e user is logged in then show the logout button */}
              {!localStorage.getItem('token')?<form className="d-flex">
              <Link className="btn btn-primary mx-1" to="/login" role="button">Login</Link>
              <Link className="btn btn-primary mx-1" to="/signup" role="button">Signup</Link>
              </form>: <button onClick={handleLogout} className="btn btn-primary">Logout</button>}
            </div>
        </div>
        </nav>
    </>
  )
}

export default Navbar